export const NAV_LINKS = [
  { label: "Home", href: "/", testId: "nav-home" },
  { label: "Services", href: "/services", testId: "nav-services" },
  { label: "Our Work", href: "/work", testId: "nav-work" },
  { label: "Industries", href: "/industries", testId: "nav-industries" },
  { label: "About", href: "/about", testId: "nav-about" },
  { label: "Insights", href: "/insights", testId: "nav-insights" },
  { label: "Contact", href: "/contact", testId: "nav-contact" },
];

export const SERVICES = [
  {
    key: "web",
    title: "Website Development",
    lead: "Marketing sites that convert. Corporate sites that command trust.",
    items: ["Business Websites", "Corporate Websites", "Landing Pages", "Portfolio Websites", "Service Company Websites"],
    icon: "Globe",
  },
  {
    key: "ecom",
    title: "E-Commerce",
    lead: "Storefronts engineered for speed, scale and conversion.",
    items: ["Online Stores", "Product Catalogues", "Payment Integration", "Inventory Systems", "Customer Portals"],
    icon: "ShoppingBag",
  },
  {
    key: "software",
    title: "Software Development",
    lead: "Custom software that becomes your operational advantage.",
    items: ["Business Automation Platforms", "CRM Systems", "Client Portals", "Dashboards", "SaaS Applications", "Booking Systems", "Marketplace Platforms", "Internal Business Systems"],
    icon: "Code2",
  },
  {
    key: "automation",
    title: "Automation",
    lead: "Reclaim hours per week with intelligent workflow automation.",
    items: ["Workflow Automation", "CRM Integration", "AI Chatbots", "WhatsApp Integration", "Business Process Automation"],
    icon: "Workflow",
  },
  {
    key: "cloud",
    title: "Cloud & Infrastructure",
    lead: "Enterprise-grade hosting, email and domains under one roof.",
    items: ["Domain Registration", "Business Email Setup", "Website Hosting", "SSL Certificates", "Website Migration"],
    icon: "Cloud",
  },
  {
    key: "security",
    title: "Cybersecurity",
    lead: "Continuous protection engineered for modern threats.",
    items: ["Security Assessments", "Website Protection", "Monitoring", "Security Best Practices"],
    icon: "Shield",
  },
  {
    key: "support",
    title: "Support & Maintenance",
    lead: "SLAs, uptime and continuous improvement — post-launch and beyond.",
    items: ["Website Maintenance", "Software Support", "Updates", "Performance Optimisation"],
    icon: "LifeBuoy",
  },
];

export const PROCESS = [
  { step: "01", title: "Discovery", desc: "We map goals, constraints, and success metrics with your team." },
  { step: "02", title: "Planning", desc: "Scope, architecture, and delivery cadence — signed off before design." },
  { step: "03", title: "Design", desc: "Premium visual language, interaction, and motion design." },
  { step: "04", title: "Development", desc: "Ship in weekly milestones with shared previews and instrumentation." },
  { step: "05", title: "Testing", desc: "Accessibility, performance, security, and end-to-end regression." },
  { step: "06", title: "Launch", desc: "Zero-downtime rollout with monitoring and incident readiness." },
  { step: "07", title: "Ongoing Support", desc: "SLAs, iteration cycles, and roadmap ownership as your partner." },
];

export const INDUSTRIES = [
  "Healthcare", "Recruitment", "Construction", "Hospitality", "Retail",
  "Education", "Finance", "Legal", "Real Estate", "Manufacturing",
  "Logistics", "Cleaning Services", "Professional Services", "Government",
];

export const STATS = [
  { label: "Projects Delivered", value: 180, suffix: "+" },
  { label: "Businesses Supported", value: 120, suffix: "+" },
  { label: "Years Combined Experience", value: 45, suffix: "+" },
  { label: "Customer Satisfaction", value: 98, suffix: "%" },
  { label: "Avg. Delivery", value: 4, suffix: " wks" },
];

export const MANIFESTO = [
  { n: "01", title: "Product, not brochure", body: "We treat marketing pages as shipping products — performance budgets, motion systems, analytics." },
  { n: "02", title: "Design as engineering", body: "Design decisions are versioned, tested and defended with data — not opinions." },
  { n: "03", title: "Motion with intent", body: "Every animation earns its place. Nothing decorative, everything purposeful." },
  { n: "04", title: "Own the outcome", body: "We stay after launch. Retention, iteration, and roadmap ownership as partners." },
];

export const SERVICE_TYPES = [
  "Business Website", "E-Commerce", "Business Automation", "Custom Software",
  "Mobile Application", "Hosting", "Domain Registration", "Maintenance", "Other",
];
export const BUDGETS = ["Under £500", "£500–£1,000", "£1,000–£2,500", "£2,500–£5,000", "£5,000–£10,000", "£10,000+", "Prefer not to say"];
export const TIMELINES = ["Immediately", "2–4 Weeks", "1–3 Months", "Flexible"];
export const COUNTRIES = ["United Kingdom", "United States", "Canada", "Australia", "United Arab Emirates", "Nigeria", "Kenya", "South Africa", "India", "Germany", "France", "Other"];
